module.exports = __webpack_public_path__ + "img/symbol_9.0bc85a95.png";